<ol class="breadcrumb page-breadcrumb">
    <li class="breadcrumb-item">
        <a href="javascript:void(0);" [routerLink]="['/admin/home']">Home</a>
    </li>
    <li class="breadcrumb-item active">Usuários</li>
    <li class="position-absolute pos-top pos-right d-none d-sm-block"><span class="js-get-date"></span></li>
</ol>
<div class="row">
    <!-- begin col-12 -->
    <div class="col-xl-12">
        <div id="panel-8" class="panel">
            <div class="panel-hdr bg-primary-600 bg-primary-gradient">
                <h2>Lista de Usuários</h2>
                <div class="panel-toolbar ml-2">
                    <button type="button" class="btn btn-success btn-xs" data-toggle="tooltip" title="Novo Usuário" [routerLink]="['/admin/user']">Novo</button>
                </div>
            </div>
            <div class="panel-container show">
                <div class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex">
                    <div class="col-sm-12" *ngIf="!showTable">
                        <div class="alert alert-warning m-2" role="alert">{{returnMessage}}</div>
                    </div>
                    <div class="col-sm-12" *ngIf="showTable">
                        <managed-table [dataTitle]="" [rows]="users" [columns]="columns" [hasActions]="true" [hasFilter]="true"
                            [previewEnable]="false" (previewClick)="preview($event)"
                            [deleteEnable]="true" (deleteClick)="delete($event)"
                            [editEnable]="true" (editClick)="edit($event)"
                            [auxEnable]="true" [auxIcon]="auxIcon" [titleAux]="auxTitle" (auxClick)="resetarSenha($event)"
                            [auxEnable2]="true" [auxIcon2]="auxIconLock" [titleAux2]="auxTitleLock" (auxClick2)="lockUser($event)">
                        </managed-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end col-12 -->
</div>
<!-- end row -->
